/* ===========================================================
   BAMBUNO LP — bambuno-script.js（Shopify用）
   ※ クラス名を bambuno- プレフィックス付きに変更
=========================================================== */

(function () {
    'use strict';

    /* -------------------------------------------------------
       1. Hero — ズームアウトアニメーション
    ------------------------------------------------------- */
    const hero = document.querySelector('.bambuno-hero');
    if (hero) {
        requestAnimationFrame(() => {
            hero.classList.add('is-ready');
        });
    }

    /* -------------------------------------------------------
       2. スクロールフェードイン（IntersectionObserver）
    ------------------------------------------------------- */
    const animTargets = document.querySelectorAll(
        '.bambuno-fade-in, .bambuno-fade-in-up, .bambuno-fade-in-left, .bambuno-fade-in-right'
    );

    if ('IntersectionObserver' in window) {
        const observer = new IntersectionObserver(
            (entries) => {
                entries.forEach((entry) => {
                    if (entry.isIntersecting) {
                        const el = entry.target;
                        el.classList.add('is-visible');
                        observer.unobserve(el);
                        el.addEventListener('transitionend', () => {
                            el.style.willChange = 'auto';
                        }, { once: true });
                    }
                });
            },
            {
                threshold: 0.08,
                rootMargin: '0px 0px -24px 0px',
            }
        );

        animTargets.forEach((el) => observer.observe(el));
    } else {
        animTargets.forEach((el) => el.classList.add('is-visible'));
    }

    /* -------------------------------------------------------
       3. Q&A アコーディオン
    ------------------------------------------------------- */
    const qaQuestions = document.querySelectorAll('.bambuno-qa__question');

    qaQuestions.forEach((question) => {
        question.addEventListener('click', toggleQA);
        question.addEventListener('keydown', (e) => {
            if (e.key === 'Enter' || e.key === ' ') {
                e.preventDefault();
                toggleQA.call(question);
            }
        });
    });

    function toggleQA() {
        const expanded = this.getAttribute('aria-expanded') === 'true';
        const answerId = this.getAttribute('aria-controls');
        const answer = document.getElementById(answerId);

        if (!answer) return;

        this.setAttribute('aria-expanded', String(!expanded));

        if (expanded) {
            answer.style.maxHeight = answer.scrollHeight + 'px';
            requestAnimationFrame(() => {
                answer.style.transition = 'max-height 0.3s ease, opacity 0.25s ease';
                answer.style.maxHeight = '0';
                answer.style.opacity = '0';
                answer.style.overflow = 'hidden';
            });
            answer.addEventListener('transitionend', function handler() {
                answer.hidden = true;
                answer.style.cssText = '';
                answer.removeEventListener('transitionend', handler);
            });
        } else {
            answer.hidden = false;
            answer.style.overflow = 'hidden';
            answer.style.maxHeight = '0';
            answer.style.opacity = '0';
            requestAnimationFrame(() => {
                answer.style.transition = 'max-height 0.35s ease, opacity 0.3s ease';
                answer.style.maxHeight = answer.scrollHeight + 'px';
                answer.style.opacity = '1';
            });
            answer.addEventListener('transitionend', function handler() {
                answer.style.maxHeight = '';
                answer.style.overflow = '';
                answer.style.transition = '';
                answer.removeEventListener('transitionend', handler);
            });
        }
    }

    /* -------------------------------------------------------
       4. ギャラリー - ドラッグスクロール
    ------------------------------------------------------- */
    const track = document.querySelector('.bambuno-gallery-scroll__track');
    if (track) {
        let isDown = false;
        let startX;
        let scrollLeft;

        track.addEventListener('mousedown', (e) => {
            isDown = true;
            track.style.cursor = 'grabbing';
            startX = e.pageX - track.offsetLeft;
            scrollLeft = track.scrollLeft;
        }, { passive: true });

        track.addEventListener('mouseleave', () => {
            isDown = false;
            track.style.cursor = 'grab';
        }, { passive: true });

        track.addEventListener('mouseup', () => {
            isDown = false;
            track.style.cursor = 'grab';
        }, { passive: true });

        track.addEventListener('mousemove', (e) => {
            if (!isDown) return;
            const x = e.pageX - track.offsetLeft;
            const walk = (x - startX) * 1.5;
            track.scrollLeft = scrollLeft - walk;
        }, { passive: true });

        track.style.cursor = 'grab';
    }

})();
